import React from "react"
import { Navigate, useLocation, useParams } from "react-router-dom"
import { buildQuotationPreviewPath } from "util/quotationPreviewPathUtil"

// The old preview URL (/quotation/view/:id) now opens the new Quotation Preview. Old links and
// bookmarks are redirected, keeping the router state (e.g. the skipped-hotels notice after duplicate).
const QuotationPreviewRedirect: React.FC = () => {

	const { quotation_id = "" } = useParams()
	const location = useLocation()

	return (
		<Navigate
			to={{ pathname: buildQuotationPreviewPath(quotation_id), search: location.search, hash: location.hash }}
			state={location.state}
			replace
		/>
	)
}

export default QuotationPreviewRedirect
